import { type DigitalOrderPersistenceDto } from '@/shared/api/digitalOrder';
import type { DigitalOrderFormValues } from '../../model/forms/digitalOrderForm';

export function fromDigitalFormValues(
    orderId: string,
    values: DigitalOrderFormValues
): DigitalOrderPersistenceDto | undefined {
    const client: DigitalOrderPersistenceDto['client'] = {
        first_name: values.client.firstName,
        last_name: values.client.lastName,
        phone: values.client.phone,
        email: values.client.email,
    };

    return {
        order_id: orderId,
        client: client,
        payment_method: 'CARD_ONLINE',
    };
}
